// extracted by mini-css-extract-plugin
export default {"container":"SearchLayout_container__lRXF6","header":"SearchLayout_header__n1kr5","form":"SearchLayout_form__tFY5p","not-bold":"SearchLayout_not-bold__6wAEh"};